const appUrl = {
    // baseUrl: 'https://kblive.jappuat.com:8443/',
    baseUrl: 'https://qa-knowledgebase.appinsnap.com/',
  

}
export default appUrl;
    